/* Store visibility. The PayU restriction that forced this off on 2026-08-19
   (see a9a3f03) has been lifted, so the store is back exactly as it was.

   This restores /store and every entry point into it: the route, the BottomNav
   "Remedies" tab, the Market page slider, the two Orders page buttons and the
   "View all" tile on chat product cards. Nothing was ever deleted, only gated,
   so nothing had to be rebuilt to turn it back on.

   Note this does NOT gate the product cards inside chat or the remedy quiz
   results. Those link straight out to the storefront on a server-supplied
   shop_url rather than going through /store. */
export const SHOW_STORE = true;

/* The paid remedy pitch inside chat, off for the same PayU reason.

   Covers BOTH arms of the same paywall, which are armed together:
     - IntentRemedySheet, the slide-up "Get <topic> remedies, Rs X" above the
       composer
     - ProductRecommendationCard in its locked state, the inline "Unlock for
       Rs X" card in the thread

   Gated at render only. The unlock handler, the chat history and the
   persisted pitch are all untouched, so flipping this back to true restores
   the pitch with no migration.

   Remedies a user has ALREADY paid for still render. Hiding those would take
   away bought content, which is a different decision. */
export const SHOW_CHAT_REMEDY_UPSELL = true;
